var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Edit Item"},on:{"on-hide":_vm.resetFormData}},[_c('invoice-item-form',_vm._b({key:_vm.formKey,attrs:{"client_id":_vm.value.invoice?.client_id,"new-form":false},on:{"on-submit":_vm.updateItem,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'invoice-item-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }